/* Кнопка дизайн-системы: варианты, магнитный курсор, состояния загрузки и успеха. */
import { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import { useMagnetic } from '../hooks/useMotion.js';

const VARIANTS = {
  accent: 'btn--accent',
  dark: 'btn--dark',
  outline: 'btn--outline',
  ghost: 'btn--ghost',
  ghostDark: 'btn--ghost-dark',
};

const SIZES = { sm: 'btn--sm', md: '', lg: 'btn--lg', xl: 'btn--xl' };

const Check = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none">
    <path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/**
 * state: 'idle' | 'loading' | 'done' — управляет спиннером и галочкой.
 * to / href превращают кнопку в ссылку с той же вёрсткой.
 */
const Button = forwardRef(function Button(
  {
    children, variant = 'accent', size = 'md', block = false, state = 'idle',
    magnetic = true, className = '', to, href, disabled, type = 'button', ...rest
  },
  externalRef,
) {
  const magnetRef = useMagnetic(0.3);
  const ref = magnetic ? magnetRef : externalRef;

  const classes = [
    'btn',
    VARIANTS[variant] ?? VARIANTS.accent,
    SIZES[size] ?? '',
    block ? 'btn--block' : '',
    magnetic ? 'js-magnetic' : '',
    state === 'loading' ? 'is-loading' : '',
    state === 'done' ? 'is-done' : '',
    className,
  ].filter(Boolean).join(' ');

  const inner = (
    <>
      <span className="btn__label">{children}</span>
      <span className="btn__spinner"><span className="spinner" /></span>
      <span className="btn__check"><Check /></span>
    </>
  );

  if (to) {
    return (
      <Link ref={ref} to={to} className={classes} aria-disabled={disabled || undefined} {...rest}>
        {inner}
      </Link>
    );
  }
  if (href) {
    return (
      <a ref={ref} href={href} className={classes} {...rest}>
        {inner}
      </a>
    );
  }
  return (
    <button
      ref={ref}
      type={type}
      className={classes}
      disabled={disabled || state === 'loading' || state === 'done'}
      {...rest}
    >
      {inner}
    </button>
  );
});

export default Button;
